import { useGetCombinedGames } from 'react-easyrocket';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Button } from 'src/components/Buttons/Button';
import { GameCard } from 'src/components/GameCard';
import { Skeletons } from 'src/components/Skeletons/Skeletons';
import { useRoute } from 'src/router/hooks/useRoute';

export const Page404 = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { ROUTE } = useRoute();

  const { games, isFetched } = useGetCombinedGames(
    // eslint-disable-next-line camelcase
    { per_page: 3 },
    { initialPageParam: undefined, queryKey: [], categoryId: 'top' }
  );

  const handleGoToMainButtonClick = () => {
    navigate(ROUTE.MAIN.get());
  };

  return (
    <div className="bg-PAGE_NOT_FOUND bg-top 768:bg-cover bg-no-repeat 768:bg-center w-full max-w-[1280px] min-h-[600px] py-8 px-2.5 flex flex-col justify-start items-center gap-5">
      <div className="flex flex-col justify-center items-center gap-4">
        <p className="text-nfp_heading text-5xl font-extrabold">404</p>
        <p className="text-nfp_content text-2xl 768:text-4xl font-extrabold w-full text-center">
          {t('notFoundPage.title')}
        </p>
        <p className="text-nfp_content text-base 768:text-2xl font-medium w-full text-center">
          {t('notFoundPage.content')}
        </p>
      </div>
      <Button
        label={t('notFoundPage.goToMain') as string}
        className="w-fit max-w-[300px]"
        onClick={handleGoToMainButtonClick}
      />
      <div className="grid grid-cols-3 gap-2 w-full 768:max-w-[570px]">
        {games.length !== 0 && isFetched ? (
          <>
            {games.map((game) => (
              <GameCard key={game.id} game={game} />
            ))}
          </>
        ) : (
          <Skeletons count={3} className="w-full min-h-[200px] 768:min-h-[300px]" />
        )}
      </div>
    </div>
  );
};
